import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faLanguage,
  faLocationCrosshairs,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import {
  DataBindingDirective,
  PagerPosition,
  PagerType,
  RowArgs,
  SelectionEvent,
} from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { process } from '@progress/kendo-data-query';
import { SVGIcon, filePdfIcon, searchIcon } from '@progress/kendo-svg-icons';
import { some } from 'lodash';
import moment from 'moment';
import {
  BehaviorSubject,
  Observable,
  catchError,
  finalize,
  forkJoin,
  switchMap,
  throwError,
} from 'rxjs';
import { AdminService } from 'src/app/modules/administration/services/admin.service';
import { LoadingService } from 'src/app/services/loading.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from 'src/app/shared/constants/dialog-specs';

import { AgencyRequest } from 'src/app/modules/administration/interfaces/add-to-worklist';
import { VwCompleteWorklist } from 'src/app/modules/administration/interfaces/complete-worklist';
import { VwMdeWaitlist } from 'src/app/modules/administration/interfaces/mde-waitlist';
import { Permissions } from 'src/app/shared/enums/permissions';
import { Permission } from 'src/app/shared/models/permission';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { AgencyList } from '../../interface/agency-list';
import { PageSize } from '../enums/page-sizes';
@Component({
  selector: 'app-wait-list',
  templateUrl: './wait-list.component.html',
  styleUrls: ['./wait-list.component.scss'],
  standalone: false,
})
export class WaitListComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  public globalGridView: VwCompleteWorklist[];
  public globalData: VwCompleteWorklist[];
  public globalMySelection: string[] = [];
  showNewReferralModal$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  showAssignStudentToAgencies$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public gridView: VwMdeWaitlist[];
  public gridViewData: VwMdeWaitlist[];
  public searchIcon: SVGIcon = searchIcon;
  public mySelection: string[] = [];
  public pdfSVG: SVGIcon = filePdfIcon;
  selectedGlobalWaitlist: string[];
  public types: PagerType = 'numeric';
  readonly emptySelectionCount: number = 0;
  readonly buttonCount: number = 5;
  readonly phoneLength: number = 10;
  readonly areaCode: number = 3;
  readonly phoneNumberEnd: number = 6;
  public info: boolean = true;
  public pageSizes: number[] = [
    PageSize.Minimum,
    PageSize.Few,
    PageSize.Some,
    PageSize.Many,
  ];
  public previousNext: boolean = true;
  public position: PagerPosition = 'bottom';

  selectedWaitlist: AgencyRequest[] = [];
  agencyId: string;
  type: string;
  loadSpinner: boolean;
  getAgencyDetails: AgencyList;
  mdeWaitListForm: FormGroup = new FormGroup({
    mdeWaitListSearch: new FormControl(''),
  });
  globalForm: FormGroup = new FormGroup({
    globalSearch: new FormControl(''),
  });
  user: User;
  locationCode: string;
  buildingCode: string;
  selectedAgency:VwCompleteWorklist[] = [] ;

  constructor(
    library: FaIconLibrary,
    private adminService: AdminService,
    private router: ActivatedRoute,
    private authStore: AuthStore,
    private notificationService: NotificationService,
    private loadingService: LoadingService
  ) {
    library.addIcons(faLocationCrosshairs, faLanguage, faSearch);
    this.agencyId = this.router.snapshot.paramMap.get('id');
    this.type = this.router.snapshot.paramMap.get('type');
    this.authStore.UserInfo$.subscribe((userInfo: User) => {
      this.user = userInfo;
    });
  }

  public ngOnInit(): void {
    this.loadingService.show(); // display the loader

    if (this.type === 'MDE') {
      // check user type
      forkJoin([
        this.getMdeWaitlist(),
        this.adminService.getMdeAgencyByAgencySk(this.agencyId),
      ])
        .pipe(finalize(() => this.loadingService.hide()))
        .subscribe(
          ([mdeWaitList, mdeAgencyByAgencySk]: [
            VwMdeWaitlist[],
            AgencyList
          ]) => {
            this.saveMdeWaitlist(mdeWaitList);
            this.getAgencyDetails = mdeAgencyByAgencySk;
          }
        );
    } else {
      this.gobalWorklist();
    }
  }

  getMdeWaitlist(): Observable<VwMdeWaitlist[]> {
    return this.adminService.getMdeWaitlist(this.agencyId).pipe(
      catchError((error: Error) => {
        // if API fails, throw an Error
        return throwError(() => new Error(error.message));
      })
    );
  }

  saveMdeWaitlist(response: VwMdeWaitlist[]): void {
    this.gridViewData = response;
    this.gridView = response;
  }

  gobalWorklist(): void {
    this.adminService
      .getGobalWorklist()
      .pipe(
        // if API call fails, throw error
        catchError((error: Error) =>
          throwError(() => new Error(error.message))
        ),
        finalize(() => this.loadingService.hide())
      )
      .subscribe({
        next: (response: VwCompleteWorklist[]) => {
          this.globalGridView = response;
          this.globalGridView = response;
          this.globalData = response;
        },
        error: (error: Error) => {
          // display notification that worklist was unable to be loaded
          this.notificationService.show({
            content: error.message,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'fade', duration: 1200 },
            type: { style: 'error', icon: true },
          });
        },
      });
  }

  onGobalWaitListSelectionChange(event: SelectionEvent): void {
    if (event.selectedRows.length > 0) {
      event.selectedRows.forEach((row: RowArgs) =>
        this.selectedAgency.push(row.dataItem)
      );
    }
    this.selectedGlobalWaitlist = this.globalMySelection;
  }

  onSelectionChange(event: SelectionEvent): void {
    if (event.selectedRows.length > 0) {
      event.selectedRows.forEach((row: RowArgs) =>
        this.selectedWaitlist.push(row.dataItem)
      );
    }
  }

  public addWaitList(): void {
    this.loadingService.show();
    const payload: AgencyRequest[] = this.selectedWaitlist.map(
      (data: AgencyRequest) => ({
        // display the loader once button is clicked

        // construct payload
        agencyLocationSk: data?.agencyLocationSk,
        studentSk: data?.studentSk,
      })
    );

    this.adminService
      .addToWorkList(payload) // make the first API call to get workList details
      .pipe(
        catchError((error: Error) => {
          // if first API call fails, notification message is displayed to the UI
          return throwError(() => new Error(error.message));
        }),
        switchMap(() => {
          // first API call is successful, data has been submitted successfully
          this.notificationService.show({
            content: 'Submitted Successfully',
            cssClass: 'notification-success',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'success', icon: true },
          });

          // make the second API call
          return this.getMdeWaitlist();
        }),
        finalize(() => this.loadingService.hide()) //no matter if either call passes or fails, stop the loader
      )
      .subscribe({
        next: (mdeWaitList: VwMdeWaitlist[]) => {
          // save the mdeWaitList (once second API call is successful) and reset the selection
          this.mySelection = [];
          this.saveMdeWaitlist(mdeWaitList);
        },
        error: (error: Error) => {
          this.notificationService.show({
            content: error.message,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'fade', duration: 1200 },
            type: { style: 'error', icon: true },
          });
        },
      });
  }

  public removeWaitList(): void {
    //display the loader
    this.loadingService.show();

    // construct the payload
    const payload: AgencyRequest[] = this.selectedWaitlist.map(
      (data: AgencyRequest) => ({
        agencyLocationSk: data?.agencyLocationSk,
        studentSk: data?.studentSk,
      })
    );

    this.adminService
      .removeFromWaitlist(payload)
      .pipe(
        catchError((error: Error) => {
          // if first API call fails, notification message is displayed to the UI
          return throwError(() => new Error(error.message));
        }),
        switchMap(() => {
          // first API call is successful, data has been submitted successfully
          this.notificationService.show({
            content: 'Submitted Successfully',
            cssClass: 'notification-success',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'success', icon: true },
          });

          // make the second API call
          return this.getMdeWaitlist();
        }),
        finalize(() => this.loadingService.hide()) // if api calls fail or pass stop displaying the loader
      )
      .subscribe({
        next: (mdeWaitList: VwMdeWaitlist[]) => {
          // save the mdeWaitList (once second API call is successful) and reset the selection
          this.mySelection = [];
          this.saveMdeWaitlist(mdeWaitList);
        },
        error: (error: Error) => {
          this.notificationService.show({
            content: error.message,
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'error', icon: true },
          });
        },
      });
  }

  loadAndSaveMdeWaitList(): void {
    this.getMdeWaitlist()
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe((data: VwMdeWaitlist[]) => {
        this.saveMdeWaitlist(data);
      });
  }

  openNewReferralModalHandler(): void {
    this.showNewReferralModal$.next(true);
  }

  closeModalHandler(): void {
    this.showNewReferralModal$.next(false);
    this.mdeWaitListForm.get('mdeWaitListSearch').reset();
    this.loadAndSaveMdeWaitList();
  }

  openShowAssignStudentToAgencies(): void {
    this.showAssignStudentToAgencies$.next(true);
  }

  closeAssignStudentToAgencieseModalHandler(): void {
    this.showAssignStudentToAgencies$.next(false);
    this.globalMySelection = [];
    this.globalForm.get('globalSearch').reset();
    this.gobalWorklist();
  }

  public onGlobalFilter(value: Event): void {
    this.loadingService.show(); // display the loader
    const inputValue: Event = value;
    if (inputValue) {
      this.globalGridView = process(this.globalData, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'firstName',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'lastName',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'parentName',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'nycid',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'parentEmail',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'availability',
              operator: 'contains',
              value: inputValue,
            },
          ],
        },
      }).data;

      this.dataBinding.skip = 0;
      this.loadingService.hide();
    } else {
      this.gobalWorklist(); // once API call finishes, loader is stopped
    }
  }

  public onFilter(inputValue: string): void {
    this.loadingService.show(); // display the loader
    if (inputValue) {
      this.gridView = process(this.gridViewData, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'firstName',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'lastName',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'parentName',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'nycId',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'parentEmail',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'availability',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'birthDate',
              operator: (itemValue: Date) => {
                const formattedItemValue: string =
                  moment(itemValue).format('MM/DD/YYYY');
                return formattedItemValue.includes(inputValue);
              },
            },
          ],
        },
      }).data;

      this.dataBinding.skip = 0;
      this.loadingService.hide(); // display the loader
    } else {
      this.loadAndSaveMdeWaitList();
      this.gridView = this.gridViewData;
    }
  }

  get hasAssignAgencyPermission(): boolean {
    return some(
      this.user?.selectedRole?.userPermissions,
      (x: Permission) => x.permissionId === Permissions.CanAssignToAgency
    );
  }

  formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    const digits: string = phone.replace(/\D/g, '');
    if (digits.length === this.phoneLength) {
      return `(${digits.slice(0, this.areaCode)}) ${digits.slice(
        this.areaCode,
        this.phoneNumberEnd
      )}-${digits.slice(this.phoneNumberEnd)}`;
    }
    return phone;
  }
}
